import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header" }, "Informations de l'utilisateur", -1)),
    _createVNode(_component_v_form, {
      ref: "form",
      modelValue: _ctx.valid,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.valid) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Nom",
                  modelValue: _ctx.user_.lastname,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user_.lastname) = $event)),
                  rules: _ctx.lastNameRules,
                  error: _ctx.isLastnameError,
                  "error-messages": _ctx.lastnameErrorMessage,
                  "hide-details": "auto"
                }, null, 8, ["modelValue", "rules", "error", "error-messages"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Prénom",
                  modelValue: _ctx.user_.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user_.name) = $event)),
                  rules: _ctx.nameRules,
                  error: _ctx.isNameError,
                  "error-messages": _ctx.nameErrorMessage,
                  "hide-details": "auto"
                }, null, 8, ["modelValue", "rules", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "E-mail",
                  type: "email",
                  modelValue: _ctx.user_.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user_.email) = $event)),
                  rules: _ctx.emailRules,
                  error: _ctx.isEmailError,
                  "error-messages": _ctx.emailErrorMessage,
                  "hide-details": "auto"
                }, null, 8, ["modelValue", "rules", "error", "error-messages"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Numéro de téléphone",
                  modelValue: _ctx.user_.phoneNumber,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user_.phoneNumber) = $event)),
                  rules: _ctx.phoneNumberRules,
                  error: _ctx.isPhoneNumberError,
                  "error-messages": _ctx.phoneNumberErrorMessage,
                  "hide-details": "auto"
                }, null, 8, ["modelValue", "rules", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}